import "flowbite";
import AdminPrifile from "./AdminProfile";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import Loading from "../Loading";

import { ethers } from "ethers";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

//cutom Signer
const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);

// end Custom Signer
const CreatorDashboard = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  const [totalFiatPayment, setTotalFiatPayment] = useState("");
  const [totalCryptoPayment, setTotalCryptoPayment] = useState("");

  const [smallSub, setSmallSub] = useState("");
  const [mediumSub, setMediumSub] = useState("");
  const [largeSub, setLargeSub] = useState("");
  const [totalSub, setTotalSub] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const getPriceHistory = async () => {
    setIsLoading(true);

    try {
      await axios
        .get(`${process.env.REACT_APP_SERVER_URL}/payment-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setIsLoading(false);

          setTotalFiatPayment(res.data.totalFiatPayment);
          setTotalCryptoPayment(res?.data?.totalCryptoPayment?.toFixed(5));
        });
    } catch (error) {
      setIsLoading(false);
      console.error("Error logging in:", error);
      localStorage.setItem("reload", true);
      navigate("/#");
    }
  };

  const getBoxesHistory = async () => {
    let res = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/subscription-history`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("get subscription History: ", res);
    setSmallSub(res.data.data.smallSubscription);
    setMediumSub(res.data.data.mediumSubscription);
    setLargeSub(res.data.data.largeSubscription);
    setTotalSub(res.data.data.totalSubscription);
  };

  useEffect(() => {
    getPriceHistory();
    getBoxesHistory();
  }, []);

  return (
    <div style={{ opacity: 1 }} className="relative z-50">
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <AdminPrifile />

          <div
            id="adminContent"
            className="bg-[#151c2c] col-span-9 rounded-lg p-6 my-10 relative z-30"
          >
            <div>
              <h1 className="font-bold py-4 uppercase">Revenue</h1>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 md:px-28 px-4 py-10 justify-around">
                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Fiat Revenue
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {totalFiatPayment >= 0 ? totalFiatPayment : "0"} USD
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Crypto Revenue
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {totalCryptoPayment >= 0 ? totalCryptoPayment : "0"}{" "}
                            Matic
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h1 className="font-bold py-4 uppercase">Boxes</h1>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 md:px-28 px-4 py-10 justify-around">
                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    total Subscriptions
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {totalSub >= 0 ? totalSub : "0"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    small Subscription
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {smallSub >= 0 ? smallSub : "0"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Medium Subscription
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {mediumSub >= 0 ? mediumSub : "0"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Large Subscription
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {largeSub >= 0 ? largeSub : "0"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        onClick={() => {
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>

      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default CreatorDashboard;
